import { Injectable, Output, EventEmitter, OnInit } from '@angular/core';
import Swal from 'sweetalert2';




/**
 * Service para controlar os Alerts do sistema
 */
@Injectable({
  providedIn: 'root',
})
export class MessageService implements OnInit {

  /**
   * Configuração padrão do Alert
   */
  private custom = Swal.mixin({
    showConfirmButton: false,
    showCloseButton: true
    // customClass: {
    //   cancelButton: 'btn btn-secondary margin-swal',
    //   confirmButton: 'btn btn-primary margin-swal'
    // }
  });

  /**
   * @ignore
   */
  ngOnInit(): void {
  }

  information(message: string, title: string) {
    this.custom.fire(title, message, 'info');
  }

  error(message: string, title: string) {
    this.custom.fire(title, message, 'error');
  }

  errorDefault(){
    this.custom.fire('Por favor, tente novamente mais tarde.','Ocorreu um erro', 'error');
  }

  warning(message: string, title: string) {
    this.custom.fire(title, message, 'warning');
  }

  question(message: string, title: string) {
    this.custom.fire(title, message, 'question');
  }

  success(message: string, title: string) {
    this.custom.fire(title, message, 'success');
  }
}